// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"7791421a","826":"263363e9"}[chunkId] + ".chunk.js";
};